var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.9 22",
    style: {
      enableBackground: "new 0 0 22.9 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M16.7,0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.4,0.2L0.7,15.6c-0.1,0.1-0.2,0.3-0.2,0.4l-0.3,5.1 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.2l5.1-0.3c0.2,0,0.3-0.1,0.4-0.2L21.5,6.2c0.1-0.1,0.2-0.3,0.2-0.4s-0.1-0.3-0.2-0.4 L16.7,0.5z M5.6,20.3l-2.7,0.2l-0.1-0.3c-0.1-0.5-0.5-0.9-1-1L1.6,19l0.2-2.7l0.1-0.1l12-12l1.5,1.5L3.9,17.2 c-0.2,0.2-0.2,0.6,0,0.9c0.2,0.2,0.6,0.2,0.9,0L16.2,6.7l1.5,1.5L5.6,20.3z M18.6,7.3l-3.9-3.9l1.6-1.6l3.9,3.9L18.6,7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22,20.4H10.9c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6H22c0.3,0,0.6-0.3,0.6-0.6S22.4,20.4,22,20.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditer);
export default __webpack_public_path__ + "static/media/Editer.246ee745.svg";
export { ForwardRef as ReactComponent };